import React, { useState } from 'react';
import { Layout, Drawer, Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { useResponsive } from '../utils/responsive';
import { useLocale } from '../contexts/LocaleContext';

const { Header, Sider, Content } = Layout;

interface ResponsiveLayoutProps {
  children: React.ReactNode;
  sidebar?: React.ReactNode;
  header?: React.ReactNode;
}

const ResponsiveLayout: React.FC<ResponsiveLayoutProps> = ({ 
  children, 
  sidebar, 
  header 
}) => {
  const { isMobile, isTablet } = useResponsive();
  const { isRTL } = useLocale();
  const [drawerVisible, setDrawerVisible] = useState(false);

  const isMobileOrTablet = isMobile || isTablet;

  const toggleDrawer = () => {
    setDrawerVisible(!drawerVisible);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
  };

  if (isMobileOrTablet) {
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Header 
          style={{ 
            background: '#fff', 
            padding: '0 16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            zIndex: 1000
          }}
        >
          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={toggleDrawer}
            style={{ fontSize: '18px' }}
          />
          {header}
        </Header>
        
        <Drawer
          title="منو"
          placement={isRTL ? 'right' : 'left'}
          onClose={closeDrawer}
          open={drawerVisible}
          width={280}
          styles={{ body: { padding: 0 } }}
        >
          {sidebar}
        </Drawer>
        
        <Content style={{ padding: '16px' }}>
          {children}
        </Content>
      </Layout>
    );
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        width={280}
        style={{
          background: '#fff',
          boxShadow: isRTL ? '2px 0 8px rgba(0,0,0,0.1)' : '-2px 0 8px rgba(0,0,0,0.1)',
          zIndex: 1000
        }}
      >
        {sidebar}
      </Sider>
      
      <Layout>
        <Header 
          style={{ 
            background: '#fff', 
            padding: '0 24px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          {header}
        </Header>
        
        <Content style={{ padding: '24px' }}>
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default ResponsiveLayout;
